import { SxProps } from '@mui/material';
import { surfaceGrey, textPrimary, white } from '../ThemeProvider/colors';

// export const select: SxProps = {
//   border: 'none',
//   background: 'transparent',
//   color: black,
//   outline: 'none',
//   cursor: 'pointer',
//   borderRadius: 0,
//   // paddingRight: '16px !important',
//
//   '& .MuiSvgIcon-root': {
//     color: black,
//   },
//
//   '& .MuiSelect-select': {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     paddingRight: '18px !important',
//   },
//
//   '& .MuiSelect-select:focus': {
//     background: 'transparent',
//   },
//
//   '& .MuiSelect-icon': {
//     width: '15px',
//     height: '20px',
//   },
//
//   '&::before': {
//     display: 'none',
//   },
//
//   '&::after': {
//     display: 'none',
//   },
// };

// export const menu: SxProps = {
//   boxShadow: '1px 1px 10px #888',
// };

// export const selectorText: SxProps = {
//   ml: '7px',
//   fontSize: '12px',
//   fontFamily: 'Yelo',
// };

export const languageButton: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
  height: '56px',
  minWidth: 0,
  p: '16px 0px 16px 16px',
  background: 'transparent',
  textTransform: 'none',

  '&:hover': {
    background: 'transparent',
  },

  '& .MuiSvgIcon-root': {
    width: '24px',
    height: '24px',
  },
};

/** Kompakt rejimdə dropdown bir qədər sola sürüşsün və aşağıdan açılsın */
export const languageMenuPaperCompact: SxProps = {
  ml: '-20px',
  mt: '12px',
};

/** Kompakt (mobil header) — yalnız 24x24 bayraq, şaquli padding yoxdur */
export const languageButtonCompact: SxProps = {
  height: 'auto',
  p: 0,
  gap: 0,

  '& .MuiSvgIcon-root': {
    width: '24px',
    height: '24px',
  },
};

export const languageValue: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
};

export const languageLabel: SxProps = {
  fontFamily: 'Yelo',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '24px',
  color: textPrimary,
};

/** Figma: submenu list — 134px en, 4px daxili boşluq */
export const languageMenuPaper: SxProps = {
  width: '134px',
  mt: '4px',
  p: '4px',
  background: white,
  boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.11)',
  borderRadius: '10px',

  '& .MuiList-root': {
    p: 0,
  },
};

export const languageMenuItem: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  height: '56px',
  p: '16px',
  background: white,
  borderRadius: '10px',
  textDecoration: 'none',

  '&:hover': {
    background: surfaceGrey,
  },
};

export const languageMenuLabel: SxProps = {
  flexGrow: 1,
  fontFamily: 'Yelo',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  color: textPrimary,
};
